export default __webpack_public_path__ + "static/media/Kofax.16c9b4ac.png";